import axiosHttp from "services/axiosHttp";
import { permissionCreateOrUpdate } from "./PermissionCreateSlice";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchRoleList = createAsyncThunk("userManagement/fetchRoleList", async () => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`roles/list`, config);

	return response.data.data;
});

export const createRole = createAsyncThunk("userManagement/createRole", async (role) => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	};

	const response = await axiosHttp.post(`roles/create`, role, config);

	return response.data.data;
});

export const updateRole = createAsyncThunk("userManagement/updateRole", async ({ id, data }) => {
	const response = await axiosHttp.put(`roles/${id}`, data);
	return response.data.data;
});

export const cloneRole = createAsyncThunk("userManagement/cloneRole", async ({ sourceRoleId, name, displayName, permissions }, { dispatch }) => {
	const created = await dispatch(createRole({ name, displayName })).unwrap();
	const newRoleId = created?.id;

	const permissionsToClone = (permissions || []).filter((permission) => permission.role_id === sourceRoleId);

	// sequential on purpose: firing every permission upsert at once bursts past the
	// backend's rate limiter, and a couple would silently fail even though this
	// resolves as "done" — so assign them one at a time and let a failure surface.
	for (const permission of permissionsToClone) {
		await dispatch(
			permissionCreateOrUpdate({
				roleId: newRoleId,
				moduleId: permission.module_id,
				componentId: permission.component_id,
				status: true,
			})
		).unwrap();
	}

	return created;
});

const userManagementRoleListSlice = createSlice({
	name: "userManagementRoleList",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		mutationSuccess: false,
	},

	reducers: {
		resetStateRoleList: (state) => {
			state.isLoading = false;
			state.error = null;
			state.data = null;
			state.mutationSuccess = false;
		},
		resetRoleMutationState: (state) => {
			state.mutationSuccess = false;
		},
	},

	extraReducers: (builder) => {
		builder.addCase(fetchRoleList.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchRoleList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchRoleList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});

		builder.addCase(createRole.pending, (state) => {
			state.isLoading = true;
			state.mutationSuccess = false;
		});
		builder.addCase(createRole.fulfilled, (state) => {
			state.isLoading = false;
			state.mutationSuccess = true;
		});
		builder.addCase(createRole.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
			state.mutationSuccess = false;
		});

		builder.addCase(updateRole.pending, (state) => {
			state.isLoading = true;
			state.mutationSuccess = false;
		});
		builder.addCase(updateRole.fulfilled, (state) => {
			state.isLoading = false;
			state.mutationSuccess = true;
		});
		builder.addCase(updateRole.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
			state.mutationSuccess = false;
		});

		builder.addCase(cloneRole.pending, (state) => {
			state.isLoading = true;
			state.mutationSuccess = false;
		});
		builder.addCase(cloneRole.fulfilled, (state) => {
			state.isLoading = false;
			state.mutationSuccess = true;
		});
		builder.addCase(cloneRole.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
			state.mutationSuccess = false;
		});
	},
});

export const { resetStateRoleList, resetRoleMutationState } = userManagementRoleListSlice.actions;
export default userManagementRoleListSlice.reducer;
